import React, { useEffect, useState } from 'react';
import DropdownSelect from "components/Dropdown/DropdownSelect";
import { LandPlot } from "lucide-react";

export default function Course({
    leagueName,
    clearAllScores,
    avaliableSeasons,
    season,
    setSeason,
    club,
    setClub,
    course,
    setCourse,
    tee,
    setTee,
    date,
    setDate,
    signatureEvent,
    setSignatureEvent,
    eventName,
    setEventName
}) {
    // Move to firebase?
    const clubs = [
        { "name": "Halmstad GK", id: "000" },
        { "name": 'Ringenäs GK', id: "111", }
    ];
    // Move to fiebase?
    const courses = {
        "Halmstad GK": [{ name: "Norra", id: "000" }, { name: "Södra", id: "111" }],
        "Ringenäs GK": [{ name: "Gul/Blå", id: "000" }, { name: "Blå/Röd", id: "111" }],
    };
    // Move to firease?
    const tees = {
        "Norra": [{ name: "Svart", id: "000" }, { name: "Vit", id: "111" }, { name: "Gul", id: "222" }, { name: "Blå", id: "333" }, { name: "Röd", id: "444" }],
        "Södra": [{ name: "Vit", id: "000" }, { name: "Gul", id: "111" }, { name: "Blå", id: "222" }, { name: "Röd", id: "333" }],
        "Ringenäs": [{ name: "Vit", id: "000" }, { name: "Gul", id: "111" }, { name: "Röd", id: "222" }]
    };




    // Set default at start
    useEffect(() => {
        const today = new Date().toISOString().split("T")[0];
        setDate(today);
    }, [setDate]);



    useEffect(() => {
        if (clearAllScores) {
            setClub('');
            setCourse('');
        }
    }, [clearAllScores]);

    const handleClubChange = (item) => {
        console.log(item)
        setClub(item);
        if (item.name != club) {
            setCourse('');
        }
        setClub(item);
    };

    const handleCourseChange = (item) => {
        setCourse(item)
    };

    const handleDateChange = (event) => {
        setDate(event.target.value);
    };
    const handleTeeChange = (item) => {
        setTee(item)
    };

    const handleSeasonChange = (item) => {
        setSeason(item)
    };
    const handleSignatureEventChange = (item) => {
        console.log(item.target.checked)
        setSignatureEvent(item.target.checked)

    };
    const handleEventNameChange = (item) => {
        console.log(item.target.value)
        setEventName(item.target.value)

    };

    return (
        <div className="course-data">
            <div className="course-information">

                <div className="base-information">
                    <LandPlot size={45} />
                    <div className="">
                        <h3>{leagueName}{season?.name}</h3>
                        <p>Fyll i baninformation och omgångens resultat</p>
                    </div>
                </div>

                <div className="signature-event-select">
                    <div className="form-group form-group--horizontal toggle">
                        <span>Signatur event</span>
                        <label htmlFor="signatureEvent" className="switch">
                            <input type="checkbox" id="signatureEvent" name="signatureEvent" onChange={handleSignatureEventChange} />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className={`form-group`}>
                        <label htmlFor="eventName">Namn</label>
                        <input type='text' id="eventName" name="eventName" onChange={handleEventNameChange} />
                    </div>
                </div>

            </div>
            <div className="course-information-input-fields">
                <div className="form-group">
                    <span >Säsong</span>
                    <DropdownSelect
                        items={avaliableSeasons}
                        value={season?.id || ""}
                        onChange={handleSeasonChange}
                        placeholder="Välj säsong"
                        name="season"
                    />
                </div>
                <div className="form-group form-group--date-select">

                    <label htmlFor="date-select" >Datum</label>
                    <input id="" className="date-select" value={date} name='date' type='date' onChange={handleDateChange} />

                </div>
                <div className="form-group">
                    <span >Klubb</span>
                    <DropdownSelect
                        items={clubs}
                        value={club?.id || ""}
                        onChange={handleClubChange}
                        placeholder="Välj Klubb"
                    />

                </div>
                <div className="form-group">
                    <span >Bana</span>
                    <DropdownSelect
                        items={courses[club.name]}
                        value={course?.id || ""}
                        onChange={handleCourseChange}
                        placeholder="Välj bana"
                    />


                </div>
                <div className="form-group">
                    <span >Tee</span>
                    <DropdownSelect
                        items={tees[course.name]}
                        value={tee?.id || ""}
                        onChange={handleTeeChange}
                        placeholder="Välj tee"
                    />
                </div>


            </div>
        </div >
    );
}
